<div class="custom-snackbar">
    <span>{{ data.message }}</span>
    <button mat-button (click)="openLink()" class="edit-link">Edit</button>
    <button mat-button (click)="closeSnackbar($event)" class="close-link">Close</button>
</div>

